import type { ReviewedFundingRequestVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveReviewedFundingRequests = createApiThunk<ReviewedFundingRequestVM[], void>(
  "fundingRequests/retrieveReviewedFundingRequests",
  async (_: void, { extra: { adminRepository } }) => {
    const requests = await adminRepository!.getAll({ status: ["reviewed"] });
    const response: ReviewedFundingRequestVM[] = [];
    for (const r of requests) {
      if (r.status === "reviewed") {
        response.push(r);
      }
    }
    return response;
  },
);
